import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
    children: ReactNode;
}

type State = {
    error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error("[ErrorBoundary]", error, info.componentStack);
    }

    render(): ReactNode {
        if (this.state.error) {
            return (
                <div className="alert alert-danger m-3">
                    <strong>Une erreur est survenue</strong>
                    <p className="mb-0 mt-1">{this.state.error.message}</p>
                </div>
            );
        }

        return this.props.children;
    }
}
